import { RouterType } from '@online-webinar/router';
import { InvitedParticipants } from '@online-webinar/webinar-management';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/$webinarId/invites/'].update({
        staticData: { title: { page: 'Invites.PageHeading', forWebinar: true } },
        component: authGuard(InvitedParticipants, { canBroadcast: true, isWhitelabel: true })
    });
};
